import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { IAttendanceReports, IAttendanceReportSummary, IExcelDownloadResponse, IFilterAttendanceReports } from '../data/attendance-reports';

@Injectable({
  providedIn: 'root'
})
export class AttendanceReportsService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}AttendanceReports`

  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }

  getAttendanceReports(filter: IFilterAttendanceReports): Observable<ResponseDefault<IAttendanceReports[]>> {
    let params = new HttpParams().appendAll({
      pageNumber: filter.pageNumber.toString(),
      pageSize: filter.pageSize.toString(),
      orderBy: filter.orderBy.toString()
    })

    if (filter.companyId) {
      params = params.append('companyId', filter.companyId)
    };
    if (filter.partnerId) {
      params = params.append('partnerId', filter.partnerId)
    };
    if (filter.searchText) {
      params = params.append('searchText', filter.searchText)
    }
    if (filter.selectedDate) {
      params = params.append('selectedDate', filter.selectedDate)
    }
    if (filter.startDate) {
      params = params.append('startDate', filter.startDate)
    }
    if (filter.endDate) {
      params = params.append('endDate', filter.endDate)
    }
    if (filter.selectedAttendant) {
      params = params.append('selectedAttendant', filter.selectedAttendant)
    }

    return this.http.get<ResponseDefault<IAttendanceReports[]>>(`${this.apiUrl}/GetAttendanceReports`, { params });
  }

  getAttendanceReportById(id: string): Observable<ResponseDefault<IAttendanceReports>> {
    return this.http.get<ResponseDefault<IAttendanceReports>>(`${this.apiUrl}/GetAttendanceReport/${id}`);
  }

  updateAttendanceReport(id: string, attendanceReport: IAttendanceReportSummary): Observable<ResponseDefault<IAttendanceReportSummary>> {
    return this.http.put<ResponseDefault<IAttendanceReportSummary>>(`${this.apiUrl}/GetAttendanceReport/${id}`, attendanceReport);
  }

  exportarExcelAttendanceReports(filters: IFilterAttendanceReports): void {
    this.http.post<IExcelDownloadResponse>(`${this.apiUrl}/ExportExcel`, filters).subscribe((resposta) => {
      saveAs(`data:${resposta.contentType};base64,${resposta.fileContents}`, resposta.fileDownloadName);
    });
  }
}
